// extracted by mini-css-extract-plugin
export default {"numericInput":"views-ProductPage-configurators-numericInput-themes-BGH-style__numericInput--Dktdi"};